import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { ProfileContext } from 'components/Profile/ProfileContext'
import { FlagIcon } from '@heroicons/react/24/outline'
import { ff, flags } from 'functions/roleBasedAccessUtils'

export default function KinesisEventCalendarEventItem({ eventData }) {

    const { ShowModal } = useContext(ModalContext)
    const { ReloadTrainingChartData } = useContext(ProfileContext)

    const profileType = useSelector(state => state.athleteProfile.profileType)

    const canEditKinesisProfileEvents = ff(flags.canEditKinesisProfileEvents, { profileType: profileType })

    const OpenEventManagementModal = () => {
        const modalData = {
            key: ModalKey.EventManagement,
            size: 'fullscreen',
            ReloadTrainingChartData: ReloadTrainingChartData
        }

        ShowModal(modalData)
    }

    return (
        <div 
            onClick={canEditKinesisProfileEvents ? () => OpenEventManagementModal() : null}
        >
            <div className='flex items-center gap-x-0.5'>
                <div>
                    <FlagIcon className='h-4 w-4 text-gray-400' />
                </div>

                <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
            </div>

            <div className='pl-0.5 text-gray-500 text-xxs 2xl:text-xs'>
                {eventData.extendedProps.kinesisEventData.eventType
                    .split('-')
                    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                    .join(' ')}
            </div>
        </div>
    )
}